import {getLocale} from '../common/locale';
import type {SlAlert, SlButton, SlCheckbox} from '../../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';
import {notNull} from '../../../../../library/clxProductNet/assets/js/modules/common/assert';
import ProductCustomizationConfig from './productCustomizationConfig';

export default class ProductCustomizationOrder {
    html: HTMLElement;

    // @ts-ignore
    closeCutomizationOrderFormButton: SlButton;

    // @ts-ignore
    backToCustomizationButton: SlButton;

    // @ts-ignore
    customizationOrderOverlay: HTMLDivElement;

    urlRequestCustomizationOrderForm: string;

    private dialogCustomizationFormContainer: HTMLDivElement;
    private customizerContainer: HTMLDivElement;

    // @ts-ignore
    private submitButton: SlButton;

    private config: ProductCustomizationConfig;

    constructor(config: ProductCustomizationConfig) {
        this.config = config;
        // @ts-ignore
        this.html = document.querySelector('html');
        // @ts-ignore
        this.customizerContainer = notNull(document.querySelector('#customization-order-container'));

        // All URL's for ajax actions
        this.urlRequestCustomizationOrderForm = `/${getLocale()}/product-customization-order/apiCustomizationOrderForm/`;
        // All container divs for ajax loading targets
        // @ts-ignore
        this.dialogCustomizationFormContainer = notNull(document.querySelector('#customization-order-container'));
    }

    async _openCustomizationOrderForm() {
        const formData = this.config.getAsFormdata();

        const request = await fetch(this.urlRequestCustomizationOrderForm, {
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            method: 'post',
            cache: 'no-cache',
            credentials: 'same-origin',
            body: formData,
        });

        if (request.status !== 200) {
            // TODO: Fehler anzeigen?
            return;
        }

        this.customizerContainer.innerHTML = await request.text();
        this.customizationOrderOverlay = notNull(this.customizerContainer.querySelector<HTMLDivElement>('.product-customization-order-overlay'));
        this._attachOverlayEventListeners();

        this.customizationOrderOverlay.classList.add('open');
    }

    private _attachOverlayEventListeners() {
        this.submitButton = notNull(this.customizerContainer.querySelector<SlButton>('sl-button#submitOrder'));

        this._attachAgbCheckboxEvent();
        this._submitOrderEvent();

        // @ts-ignore
        this.closeCutomizationOrderFormButton = this.customizerContainer.querySelector('.product-customization-order-overlay .close-overlay');
        this.closeCutomizationOrderFormButton.addEventListener('click', async (e) => {
            await this._closeCustomizerOrderform();
        });

        // @ts-ignore
        this.backToCustomizationButton = document.querySelector('sl-button.back-to-customization');
        this.backToCustomizationButton.addEventListener('click', async (e) => {
            await this._closeCustomizerOrderform();
        });
    }

    private _attachAgbCheckboxEvent(): void {
        const agbCheckBox = document.querySelector<SlCheckbox>('sl-checkbox[name="agb"]');
        const agbAlert = document.getElementById('agb_alert') as SlAlert;
        if (agbCheckBox) {
            agbCheckBox.addEventListener('sl-change', () => {
                if (agbCheckBox.checked) {
                    agbAlert.hide();
                }
            });
        }
    }

    private _submitOrderEvent() {
        const orderForm = this.customizerContainer.querySelector<HTMLFormElement>('#customization-order-form');
        if (orderForm) {
            this.submitButton.addEventListener('click', async (event) => {
                event.preventDefault();
                const agbCheckBox = document.querySelector<SlCheckbox>('sl-checkbox[name="agb"]');
                const agbAlert = document.getElementById('agb_alert') as SlAlert;
                if (agbCheckBox && !agbCheckBox.checked) {
                    agbAlert.show();
                    return;
                }

                const formData = new FormData(orderForm);

                const request = await fetch(orderForm.action, {
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                    method: 'post',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    body: formData,
                });

                if (request.status !== 200) {
                    // TODO: Fehler anzeigen?
                    return;
                }

                const response = await request.json();

                if (response.redirect) {
                    location.href = response.redirect;
                    return;
                }
            });
        }
    }

    _closeCustomizerOrderform() {
        this.customizationOrderOverlay.classList.remove('open');
    }
}
